import FilterCheckBoxComp from 'components/UIComponents/FilterCheckBoxComp'
import {
  SearchInput,
  Wrapper,
} from 'modules/Roles/ViewRole/CollegesTable/CollegeFilter/Styles/style'
import React, { useEffect, useState } from 'react'

const LocationFilter = ({
  locationValue,
  setLocationValue,
  atsBasedLocationList,
  setLocationSearch,
  inputWidth,
}) => {
  const [locationOptions, setLocationOptions] = useState([])
  const [filteredLocations, setFilteredLocations] = useState([])

  const [searchInput, setSearchInput] = useState('')

  useEffect(() => {
    const locations = atsBasedLocationList?.candidatelocationList?.map(item => {
      return {
        label: item,
        value: item,
      }
    })
    setLocationOptions(locations)
  }, [atsBasedLocationList])

  const handleSearchInput = e => {
    const searchTerm = e?.target?.value?.toLowerCase()
    setSearchInput(searchTerm)

    const filteredCities = locationOptions?.filter(option =>
      option?.label?.toLowerCase()?.includes(searchTerm)
    )

    const locations = filteredCities?.map(item => {
      return {
        label: item.label,
        value: item.value,
      }
    })
    setFilteredLocations(locations)
  }

  return (
    <Wrapper column>
      <div
        style={{
          position: 'sticky',
          background: 'white',
          zIndex: 1,
        }}
      >
        <SearchInput
          placeholder="Search by location"
          bordered={true}
          onChange={handleSearchInput}
          width={inputWidth || '450px'}
        />
      </div>

      <FilterCheckBoxComp
        value={locationValue}
        options={searchInput ? filteredLocations : locationOptions}
        onChange={values => setLocationValue([values[values?.length - 1]])}
      />
    </Wrapper>
  )
}

export default LocationFilter
